/**
 * @fileoverview gRPC-Web generated client stub for acompanha.operational_costs.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/operational_costs/v1/operational_costs.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.operational_costs = {};
proto.acompanha.operational_costs.v1 = require('./operational_costs_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.operational_costs.v1.OperationalCostsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.operational_costs.v1.OperationalCostsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.operational_costs.v1.ListOperationalCostsRequest,
 *   !proto.acompanha.operational_costs.v1.ListOperationalCostsResponse>}
 */
const methodDescriptor_OperationalCostsService_ListOperationalCosts = new grpc.web.MethodDescriptor(
  '/acompanha.operational_costs.v1.OperationalCostsService/ListOperationalCosts',
  grpc.web.MethodType.UNARY,
  proto.acompanha.operational_costs.v1.ListOperationalCostsRequest,
  proto.acompanha.operational_costs.v1.ListOperationalCostsResponse,
  /**
   * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.operational_costs.v1.ListOperationalCostsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.operational_costs.v1.OperationalCostsServiceClient.prototype.listOperationalCosts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/ListOperationalCosts',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_ListOperationalCosts,
      callback);
};


/**
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.operational_costs.v1.OperationalCostsServicePromiseClient.prototype.listOperationalCosts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/ListOperationalCosts',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_ListOperationalCosts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.operational_costs.v1.GetOperationalCostRequest,
 *   !proto.acompanha.operational_costs.v1.GetOperationalCostResponse>}
 */
const methodDescriptor_OperationalCostsService_GetOperationalCost = new grpc.web.MethodDescriptor(
  '/acompanha.operational_costs.v1.OperationalCostsService/GetOperationalCost',
  grpc.web.MethodType.UNARY,
  proto.acompanha.operational_costs.v1.GetOperationalCostRequest,
  proto.acompanha.operational_costs.v1.GetOperationalCostResponse,
  /**
   * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.operational_costs.v1.GetOperationalCostResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.operational_costs.v1.GetOperationalCostResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.operational_costs.v1.GetOperationalCostResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.operational_costs.v1.OperationalCostsServiceClient.prototype.getOperationalCost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/GetOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_GetOperationalCost,
      callback);
};


/**
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.operational_costs.v1.GetOperationalCostResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.operational_costs.v1.OperationalCostsServicePromiseClient.prototype.getOperationalCost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/GetOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_GetOperationalCost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.operational_costs.v1.CreateOperationalCostRequest,
 *   !proto.acompanha.operational_costs.v1.CreateOperationalCostResponse>}
 */
const methodDescriptor_OperationalCostsService_CreateOperationalCost = new grpc.web.MethodDescriptor(
  '/acompanha.operational_costs.v1.OperationalCostsService/CreateOperationalCost',
  grpc.web.MethodType.UNARY,
  proto.acompanha.operational_costs.v1.CreateOperationalCostRequest,
  proto.acompanha.operational_costs.v1.CreateOperationalCostResponse,
  /**
   * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.operational_costs.v1.CreateOperationalCostResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.operational_costs.v1.OperationalCostsServiceClient.prototype.createOperationalCost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/CreateOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_CreateOperationalCost,
      callback);
};


/**
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.operational_costs.v1.OperationalCostsServicePromiseClient.prototype.createOperationalCost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/CreateOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_CreateOperationalCost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest,
 *   !proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse>}
 */
const methodDescriptor_OperationalCostsService_UpdateOperationalCost = new grpc.web.MethodDescriptor(
  '/acompanha.operational_costs.v1.OperationalCostsService/UpdateOperationalCost',
  grpc.web.MethodType.UNARY,
  proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest,
  proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse,
  /**
   * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.operational_costs.v1.OperationalCostsServiceClient.prototype.updateOperationalCost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/UpdateOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_UpdateOperationalCost,
      callback);
};


/**
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.operational_costs.v1.OperationalCostsServicePromiseClient.prototype.updateOperationalCost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/UpdateOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_UpdateOperationalCost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest,
 *   !proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse>}
 */
const methodDescriptor_OperationalCostsService_SetOperationalCostArchived = new grpc.web.MethodDescriptor(
  '/acompanha.operational_costs.v1.OperationalCostsService/SetOperationalCostArchived',
  grpc.web.MethodType.UNARY,
  proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest,
  proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse,
  /**
   * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.operational_costs.v1.OperationalCostsServiceClient.prototype.setOperationalCostArchived =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/SetOperationalCostArchived',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_SetOperationalCostArchived,
      callback);
};


/**
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.operational_costs.v1.OperationalCostsServicePromiseClient.prototype.setOperationalCostArchived =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/SetOperationalCostArchived',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_SetOperationalCostArchived);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_OperationalCostsService_DeleteOperationalCost = new grpc.web.MethodDescriptor(
  '/acompanha.operational_costs.v1.OperationalCostsService/DeleteOperationalCost',
  grpc.web.MethodType.UNARY,
  proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.operational_costs.v1.OperationalCostsServiceClient.prototype.deleteOperationalCost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/DeleteOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_DeleteOperationalCost,
      callback);
};


/**
 * @param {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.operational_costs.v1.OperationalCostsServicePromiseClient.prototype.deleteOperationalCost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.operational_costs.v1.OperationalCostsService/DeleteOperationalCost',
      request,
      metadata || {},
      methodDescriptor_OperationalCostsService_DeleteOperationalCost);
};


module.exports = proto.acompanha.operational_costs.v1;

